import apiClient from './apiClient';
import RectificationNotesStore from '@/data/datastores/RectificationNotesStore';
import { rectificationNotes } from './schemas';

class RectificationNotesStoreGraphQL implements RectificationNotesStore {
  client = apiClient();

  async getEvaluationsToBeCorrected(section: string, catalog: string) {
    try {
      const response = await this.client.query({
        query: rectificationNotes.getEvaluationsToBeCorrected,
        variables: {
          section,
          catalog
        }
      });
      const { data } = response;
      return data;
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async RegisterRectificationOfGrade(RectificationRegisterRequest: any) {
    try {
      const response = await this.client.mutate({
        mutation: rectificationNotes.RegisterRectificationOfGrade,
        variables: RectificationRegisterRequest
      });
      const { data } = response;
      return data;
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
}
export default RectificationNotesStoreGraphQL;
